import {jsclj, resolveGoogExport} from 'dgetz/tsclj'

export function ReferralLink({sendBang, userAgentLinks, windowMedia}) {
  const {referral_link} = resolveGoogExport('ladder.agents.dashboard.referral_link')
  return referral_link(jsclj({
    'user/agent-links': userAgentLinks, 'window/media': windowMedia, 'send!': sendBang,
  }))
}

export function TrackingLinkFaqs({sendBang, agentWhatsATrackingLinkFaqToggle, agentHowDoesItWorkFaqToggle}) {
  const {tracking_link_faqs} = resolveGoogExport('ladder.agents.dashboard.referral_link')
  return tracking_link_faqs(jsclj({
    'agent/whats-a-tracking-link-faq-toggle': agentWhatsATrackingLinkFaqToggle,
    'agent/how-does-it-work-faq-toggle': agentHowDoesItWorkFaqToggle,
    'send!': sendBang,
  }))
}
